import React, { useState } from 'react';
const Dialog = ({
  npc,
  onClose
}) => {
  const [currentDialogIndex, setCurrentDialogIndex] = useState(0);
  const nextDialog = () => {
    if (currentDialogIndex < npc.dialog.length - 1) {
      setCurrentDialogIndex(currentDialogIndex + 1);
    } else {
      onClose();
    }
  };
  return <div className="absolute bottom-32 left-1/2 transform -translate-x-1/2 w-96 bg-gray-800 bg-opacity-90 rounded-lg p-4 shadow-lg border border-gray-700" data-id="element-44">
      <div className="flex items-center mb-3" data-id="element-45">
        <div className="w-10 h-10 rounded-full" style={{
        backgroundColor: npc.color
      }} data-id="element-46"></div>
        <div className="ml-3" data-id="element-47">
          <h3 className="text-white font-bold" data-id="element-48">{npc.name}</h3>
          <p className="text-gray-300 text-sm" data-id="element-49">{npc.role}</p>
        </div>
        <button className="ml-auto text-gray-400 hover:text-white" onClick={onClose} data-id="element-50">
          ✕
        </button>
      </div>
      <div className="bg-gray-900 p-3 rounded-md mb-3 min-h-[80px]" data-id="element-51">
        <p className="text-white" data-id="element-52">{npc.dialog[currentDialogIndex]}</p>
      </div>
      <div className="flex justify-between" data-id="element-53">
        <button className="bg-gray-700 hover:bg-gray-600 text-white px-4 py-2 rounded-md" onClick={onClose} data-id="element-54">
          Close
        </button>
        <button className="bg-blue-600 hover:bg-blue-500 text-white px-4 py-2 rounded-md" onClick={nextDialog} data-id="element-55">
          {currentDialogIndex < npc.dialog.length - 1 ? 'Next' : 'Goodbye'}
        </button>
      </div>
    </div>;
};
export default Dialog;